<div>
    <input [disabled]="skill.isLocked && !(Features.CONSULTANT_VIEW | FEATURES)" type="radio" [name]="name" [value]="value" [checked]="isChecked" (change)="onRadioChanged($event)" />
    <span class="radio-switch"></span>
</div>